import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export default function useSurfsideLocation() {
  const storeSelection = useSelector((state) => state.storeSelection);
  const storedLocation = useRef(null);

  useEffect(() => {
    if (
      window &&
      typeof window.surf === 'function' &&
      storeSelection &&
      storeSelection !== storedLocation.current
    ) {
      window.surf('setLocation:lume', {
        id: storeSelection,
        name: storeSelection,
      });
      storedLocation.current = storeSelection;
    }
  }, [storeSelection]);
}
